import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import { LoadingState, ValidationError } from '../../../../types/commonTypes'
import invoiceVersionApi from '../../../../middleware/api/Invoicing/Invoices/InvoiceVersion/InvoiceVersionListApi'
import {
  GetInvoiceVersionsResponse,
  invoiceVersionListSlice,
} from '../../../../types/Invoicing/Invoices/InvoiceVersion/InvoiceVersionTypes'
import { ApiLoadingState } from '../../../../middleware/api/apiList'
import { latestInvoiceVersion } from '../../../../types/ProjectManagement/Project/ProjectView/Invoices/invoicesTypes'
import { RootState } from '../../../../stateStore'

export const def = 'asdasd'

const fetchInvoiceVersions = createAsyncThunk(
  'getInvoiceVersions/fetchInvoiceVersions',
  async (invoiceId: number, thunkApi) => {
    try {
      return await invoiceVersionApi.getInvoiceVersion(invoiceId)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const initialInvoiceVersionsState: invoiceVersionListSlice = {
  invoiceVersions: [],
  isLoading: ApiLoadingState.idle,
  getLatestInvoiceVersion: {} as latestInvoiceVersion,
  activeVersionTabKey: 0,
  isGo: false,
}

const invoiceVersionsSlice = createSlice({
  name: 'invoiceVersions',
  initialState: initialInvoiceVersionsState,
  reducers: {
    setActiveVersionsTabKey: (state, action) => {
      state.activeVersionTabKey = action.payload
    },
    setIsGo: (state, action) => {
      state.isGo = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(isAnyOf(fetchInvoiceVersions.pending), (state) => {
        state.isLoading = ApiLoadingState.loading
      })
      .addMatcher(isAnyOf(fetchInvoiceVersions.fulfilled), (state, action) => {
        state.isLoading = ApiLoadingState.succeeded
        state.invoiceVersions = action.payload
      })
  },
})

const isLoading = (state: RootState): LoadingState =>
  state.projectInvoicesVersion.isLoading

const latestInvoicevesion = (state: RootState): latestInvoiceVersion =>
  state.projectInvoices.latestestInvoiceVersion

const invoiceVersionsList = (state: RootState): GetInvoiceVersionsResponse[] =>
  state.projectInvoicesVersion.invoiceVersions

const activeVersionTabKey = (state: RootState): number =>
  state.projectViewDetails.activeTabsKey

const getIsGo = (state: RootState): boolean => state.projectInvoicesVersion.isGo

const invoiceVersionsThunk = {
  fetchInvoiceVersions,
}

const invoiceVersionsSelectors = {
  isLoading,
  latestInvoicevesion,
  invoiceVersionsList,
  activeVersionTabKey,
  getIsGo,
}

export const invoiceVersionsService = {
  ...invoiceVersionsThunk,
  actions: invoiceVersionsSlice.actions,
  selectors: invoiceVersionsSelectors,
}

export default invoiceVersionsSlice.reducer
